import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EmbeddedBiResult } from 'types/DataResult';
import { Observable } from 'rxjs';
import { RESTServerRoute } from 'types/Server';

@Injectable()
export class EmbeddedPowerBiApiService {
  private readonly timeZone = this.safeGetTimezone();

  public constructor(private readonly httpClient: HttpClient) {}

  public getPowerBiToken(params: { reportName: string }): Observable<EmbeddedBiResult> {
    const headers = new HttpHeaders().set('time-zone', this.timeZone);
    return this.httpClient.post<EmbeddedBiResult>(RESTServerRoute.REST_GENERATE_TOKEN, params, {
      headers,
    });
  }

  public getReports(): Observable<string[]> {
    return this.httpClient.get<string[]>(RESTServerRoute.REST_GET_AVAILABLE_REPORTS);
  }

  private safeGetTimezone(): string {
    if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat !== 'function') {
      return 'UTC';
    }

    try {
      return Intl.DateTimeFormat().resolvedOptions()?.timeZone ?? 'UTC';
    } catch {
      return 'UTC';
    }
  }
}
